<template lang="pug">
div
    v-card(class="ma-2 pa-2" )
        v-card-title Summary
        v-card-text {{ tripSummary }}
          p <strong>For more route information, <a href="https://www.powertrip.earth/" target="_blank" class="plainLink" rel="noopener noreferrer">download the Power Trip app</a></strong>
          p The results provided below are based on Power Trip's best possible estimate and take into account factors like terrain, elevation and the physics of your EV. Other factors can affect your driving range, so this estimate may be different to your actual range.
          p By using this tool, you agree to these 
              a(href="https://powertrip.earth/terms-and-conditions") terms and conditions
    v-card(class="ma-2 pa-2" class="secondary" dark)
      v-card-title Start at {{ getName(trip.fromAddress.Address,"destination") }} with {{ startCharge }}% charge

    div( v-for="(s,index) in stops.charging_steps" :key="s.id")

        v-card(class="ma-2 pa-2" :dark="!$dealer.default_settings.theme.dark" :light="$dealer.default_settings.theme.dark == 1")
          v-card-title(v-if="index == 0") Drive to {{ s.name }}
          v-card-title(v-if="index > 0") Drive {{ stops.charging_steps[index - 1].name }} - {{ s.name }}
          v-card-text {{ (getStepData(index).dist / 1000).toFixed(2) }}kms - {{ niceDuration(getStepData(index).time) }} - {{ roundedkWh(s.used_energy) }} ({{ batteryPercent(s.used_energy)}})
        v-card(class="ma-2 pa-2")
          v-card-title {{ s.name }}
          v-card-text
            v-row(dense class="mb-2" v-if="getCharger(s)")
              v-img(v-for="c of getCharger(s).Plugs" :key="c.ID" :src="plugImage(c.Name)" max-height="40" max-width="40" class="ma-2")
            table
              tr
                td Arrive with:
                td {{ roundPercent(s.arrival_charge) }}
              tr(v-if="s.arrival_charge != s.departing_charge")
                td
                  strong Charge to:
                td
                  strong {{ roundPercent(s.departing_charge) }}
              tr(v-if="s.charging_duration")
                td Charge time:
                td about {{ niceDuration(s.charging_duration) }}
              tr(v-if="s.charging_cost")
                td Charging cost:
                td about {{ chargeCost(s.charging_cost)}}
    
    v-card(class="ma-2 pa-2" class="secondary" dark)
      v-card-title Arrive at {{ getName(trip.toAddress.Address,"destination") }} with {{ endCharge }} charge
 
</template>

<script>
export default {
  props: ["tripSummary", "stops","trip", "driver","summary","car","chargers"],
  computed: {
    startCharge() {
      return this.driver.battery;
    },
    endCharge() {
      return this.roundPercent(this.summary.arrival_charge);
    }
  },
  methods: {
    getCharger(s) {
      return this.chargers.find(e => e.ID == s.id);
    },
    plugImage(name) {
      let convertedName = name.replace(/\s/g,"_").toLowerCase() + ".png";
      return "https://powersell.appstack.me/plug_images/" + convertedName;
    },
    chargeCost(c) {
      return "$" + this.formatPrice(c);
    },
    roundPercent(value) {
      return Math.floor(value * 100) + "%"
    },
    roundedkWh(value) {
      return value.toFixed(2) + "kWh"
    },
    batteryPercent(value) {
      console.log(this.stops);
      let total = this.car.BatterySize * (this.driver.soh / 100);
      return Math.floor((value / total) * 100) + "%"
    },
    getStepData(index) {
      let data = {}
      if (this.stops) {
        if (index == 0) {
          data.dist = this.stops.charging_steps[0].cumulative_distance;
        data.time = this.stops.charging_steps[0].cumulative_time;
      } else {
        data.dist = this.stops.charging_steps[index].cumulative_distance - this.stops.charging_steps[index -1].cumulative_distance;
        data.time = this.stops.charging_steps[index].cumulative_time - this.stops.charging_steps[index -1].cumulative_time;
      }
      }
      return data;
    },
    getName(address, fallback) {
      if (address.properties.name) {
        return address.properties.name;
      }
      if (address.properties.city) {
        return address.properties.city;
      }
      if (address.Address) {
        return address.Address;
      }
      return fallback;
    }
  }
};
</script>

<style scoped>
.plainLink {
  text-decoration: none !important;
}
</style>
